module.exports = __webpack_public_path__ + "img/card_white.dc815ad7.svg";